import { API_ROUTES } from 'utils/constants';
import { RequestHelper } from 'utils/helpers';

const getLanguageList = () => RequestHelper.GET(API_ROUTES.GET_LANGUAGE_LIST());

export const CountriesService = {
  getLanguageList
};